import type { User } from '../gql';

import {
    randEmail,
    randFirstName,
    randLastName,
    randNumber,
    randUuid,
} from '@ngneat/falso';

import { mockBrand } from './brand';
import { mockRole } from './role';

const mockUser = (overwrite?: Partial<User>): User => {
    const firstName = randFirstName();
    const lastName = randLastName();
    return {
        adId: randUuid(),
        brands: [mockBrand()],
        displayName: `${firstName} ${lastName}`,
        email: randEmail({
            firstName: firstName,
            lastName: lastName,
            nameSeparator: '.',
            provider: 'bestseller',
            suffix: 'com',
        }),
        firstName: firstName,
        fullName: `${firstName} ${lastName}`,
        lastName: lastName,
        roles: Array.from({ length: randNumber({ min: 1, max: 5 }) }, () =>
            mockRole()
        ),
        userNumber: randUuid(),
        ...overwrite,
        ['__typename']: 'User',
    };
};

export { mockUser };
